import styled, { css } from 'styled-components'

import OpenInNewTabBase from '~/components/OpenInNewTab'

export const ScrollArea = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  min-height: 0;
  /* Visible so descendants (open-in-new-tab, zoom toolbar) are not
     clipped. Vertical overflow is handled by Card, not here —
     overflow-y: auto on this box would compute overflow-x as auto too. */
  overflow: visible;
  padding: 0 1.5rem 1.5rem;
`

const stageRows = ($rejecting: boolean) =>
  $rejecting ? 'minmax(0, 1fr) auto' : 'minmax(0, 1fr)'

export const Stage = styled.div<{ $rejecting: boolean }>`
  ${({ theme, $rejecting }) => css`
    display: grid;
    grid-template-rows: ${stageRows($rejecting)};
    flex: 1;
    min-height: 0;
    gap: ${$rejecting ? '1rem' : '0'};
    background-color: ${theme.colors.light};
    border: 1px solid ${theme.colors.light};
    border-radius: 0;
    padding: 0;
    box-sizing: border-box;
  `}
`

export const ImagePanel = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 0;
`

export const OpenInNewTab = styled(OpenInNewTabBase)`
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  z-index: 3;
`

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0 1.5rem 1.5rem;

  button {
    min-height: auto;
    min-width: auto;
  }
`
